module.exports = __webpack_public_path__ + "img/person.4a1beeb7.png";